import * as React from "react";

function SvgIcons8Safari(props, ref) {
  return (
    <svg viewBox="0 0 48 48" width="1em" height="1em" {...{ ...props, ref }}>
      <path
        fill="#cfd8dc"
        d="M44 24c0 11.044-8.956 20-20 20S4 35.044 4 24 12.956 4 24 4s20 8.956 20 20z"
      />
      <path
        fill="#448aff"
        d="M41 24c0 9.391-7.609 17-17 17S7 33.391 7 24 14.609 7 24 7s17 7.609 17 17z"
      />
      <path
        fill="#ff3d00"
        d="M21.898 21.898l4.203 4.203L35.3 12.699l-13.402 9.199z"
      />
      <path fill="#bf360c" d="M24 24l11.301-11.301-9.199 13.402L24 24z" />
      <path
        fill="#fff"
        d="M21.898 21.898L12.699 35.3l13.402-9.199-4.203-4.203z"
      />
      <path fill="#bdbdbd" d="M24 24L12.699 35.301l13.402-9.199L24 24z" />
      <path
        fill="#bbdefb"
        d="M17.102 10.699c.598-.301 1.199-.598 1.797-.801l1.203 2.703-1.801.797-1.199-2.699zM36 25h2.898c0-.301.102-.699.102-1s0-.699-.102-1H36v2zM12.699 14.102l2.102 2.098 1.398-1.398-2.098-2.102-1.402 1.402zm12.301-5C24.699 9 24.301 9 24 9s-.699 0-1 .102V12h2V9.102zm5.398 1.398c-.598-.301-1.199-.5-1.898-.699l-1.102 2.801 1.902.699 1.098-2.801zM12.5 20.5l.699-1.898L10.5 17.5c-.301.602-.5 1.199-.699 1.898L12.5 20.5zM12 23H9.102C9 23.301 9 23.699 9 24s0 .699.102 1H12v-2zm23.5 4.5l-.699 1.898L37.5 30.5c.301-.602.5-1.199.699-1.898L35.5 27.5zm2.602-8.602c-.203-.598-.5-1.199-.801-1.797L34.602 18.3l.797 1.801 2.703-1.203zm-2.801 15L33.199 31.8l-1.398 1.398 2.098 2.102 1.402-1.402zm-21.903-4.199l-.797-1.801-2.703 1.203c.203.598.5 1.199.801 1.797l2.699-1.199zm16.301 4.903l-1.801.797 1.203 2.703c.598-.203 1.199-.5 1.797-.801l-1.199-2.699zM20.5 35.5l-1.898-.699L17.5 37.5c.602.301 1.199.5 1.898.699L20.5 35.5zm4.5 3.398V36h-2v2.898c.301 0 .699.102 1 .102s.699 0 1-.102z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8Safari);
